import type { Config } from '../../_config'
import { FactoryDomain } from '../../_domain/FactoryDomain'
import type { ALLOWED_MARKETS } from '../domain/Market'
import { Market } from '../domain/Market'
import { ForbiddenSharedRepository } from './ForbiddenSharedRepository'

export class DomainSharedRepository extends ForbiddenSharedRepository {
  static create({ config }: { config: Config }) {
    return new DomainSharedRepository(config)
  }

  constructor(config: Config) {
    super(config)
  }

  async market() {
    const domain = await FactoryDomain.create({ config: this.config }).domain()

    const [error, host] = domain.host<(typeof ALLOWED_MARKETS)[number]>()

    if (error) return Market.empty()

    return Market.fromHostName({ hostname: host })
  }
}
